__turbopack_context__.v({
  "blogPostcardSingle": "moreArticlesAndResources-module-scss-module__qfauhW__blogPostcardSingle",
  "headline": "moreArticlesAndResources-module-scss-module__qfauhW__headline",
  "previewCardsummary": "moreArticlesAndResources-module-scss-module__qfauhW__previewCardsummary",
  "spinnerWrapper": "moreArticlesAndResources-module-scss-module__qfauhW__spinnerWrapper",
});
